module.exports = __webpack_public_path__ + "02_glasses_red.0dc97f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/02_glasses_red.png
// module id = 9C7A
// module chunks = 0